// ── CURSOR ──────────────────────────────────────────────
const dot  = document.getElementById('cur-dot-wrap');
const ring = document.getElementById('cur-ring-wrap');
let mx=-200,my=-200,rx=-200,ry=-200;
document.addEventListener('mousemove',e=>{ mx=e.clientX; my=e.clientY; });
(function tick(){
  if(dot)  dot.style.cssText=`left:${mx}px;top:${my}px`;
  rx+=(mx-rx)*.09; ry+=(my-ry)*.09;
  if(ring) ring.style.cssText=`left:${rx}px;top:${ry}px`;
  requestAnimationFrame(tick);
})();
document.querySelectorAll('a,button,.prod-card,.cart-item,.qty-btn').forEach(el=>{
  el.addEventListener('mouseenter',()=>{ if(dot) dot.classList.add('cur-expand'); if(ring) ring.classList.add('cur-expand'); });
  el.addEventListener('mouseleave',()=>{ if(dot) dot.classList.remove('cur-expand'); if(ring) ring.classList.remove('cur-expand'); });
});

// ── NAV SCROLL ──────────────────────────────────────────
const nav = document.querySelector('.site-nav');
if(nav) window.addEventListener('scroll',()=>nav.classList.toggle('scrolled',scrollY>80));

// ── SCROLL REVEAL ────────────────────────────────────────
const io = new IntersectionObserver(entries=>{
  entries.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('in'); });
},{ threshold:.1 });
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

// ── PRODUCT GALLERY THUMBS ───────────────────────────────
document.querySelectorAll('.product-thumb').forEach(thumb=>{
  thumb.addEventListener('click',()=>{
    const src = thumb.querySelector('img').src;
    const main = document.querySelector('.product-main-img img');
    if(main){ main.src=src; }
    document.querySelectorAll('.product-thumb').forEach(t=>t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// ── QUANTITY BUTTONS ─────────────────────────────────────
document.querySelectorAll('.qty-btn').forEach(btn=>{
  btn.addEventListener('click',()=>{
    const input = btn.closest('.qty-wrap,.cart-qty-wrap').querySelector('input');
    let val = parseInt(input.value)||1;
    if(btn.dataset.action==='plus') val++;
    if(btn.dataset.action==='minus') val=Math.max(1,val-1);
    input.value=val;
    // Trigger change for cart updates
    input.dispatchEvent(new Event('change'));
  });
});

// ── AJAX CART UPDATE ─────────────────────────────────────
document.querySelectorAll('.cart-qty-input').forEach(input=>{
  input.addEventListener('change',async function(){
    const key = this.dataset.key;
    const qty = parseInt(this.value)||1;
    if(!key) return;
    await fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})
    });
    updateCartCount();
  });
});

// ── REMOVE CART ITEM ─────────────────────────────────────
document.querySelectorAll('.cart-item-remove').forEach(btn=>{
  btn.addEventListener('click',async function(){
    const key = this.dataset.key;
    if(!key) return;
    await fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:0})
    });
    location.reload();
  });
});

// ── CART COUNT UPDATE ────────────────────────────────────
async function updateCartCount(){
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const count = document.querySelector('.cart-count');
  if(count){ count.textContent=cart.item_count; count.style.display=cart.item_count>0?'flex':'none'; }
}
updateCartCount();

// ── GOLD STRIP DUPLICATE ─────────────────────────────────
const track = document.querySelector('.gstrip-track');
if(track){ track.innerHTML+=track.innerHTML; }
